import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteRedirect } from '@/routing/RouteRedirect';
import { viewsBareAddressTarget } from './viewsOverviewRoute';

/**
 * F-0549 VO-1, VO-17: the bare Views address in every scope (a work area's, the current one's
 * `/-/views`, All work areas, a namespace). It is the overview; `?new=1` is the editor for a new
 * view; an old link carrying a view's query is replaced by Work items with the same query.
 */
export function ViewsIndexRoute({ overview, editor }: { overview: ReactNode; editor: ReactNode }) {
  const location = useLocation();
  const target = viewsBareAddressTarget(location.pathname, location.search);
  if (target.kind === 'work-items') {
    return <RouteRedirect to={target.to} state={location.state} />;
  }
  return <>{target.kind === 'editor' ? editor : overview}</>;
}
